import { format } from 'date-fns';

/* ascending - shortest ago to longest ago */
export function dateComparator(dateA: Date, dateB: Date, ascending = true): number {
  if (dateA > dateB) return ascending ? -1 : 1;
  if (dateB > dateA) return ascending ? 1 : -1;
  return 0;
}

/**
 * Gets an ISO 8601 date (no time) string.
 */
export function getISO8601DateString(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
